export function getInitialState() {
  const initialState = {
    vendor: [
      {
        name: "Trex",
        active: true,
      },
      {
        name: "joah",
        active: false,
      },
    ],
    vendorDraftProducts: [],
    quantity: 20,
    product: [],
    vendorPendingActionRequests: [],
    currentActionToReview: {},
    loadingActionRequests: false,
  };

  return initialState;
}
